function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 23s-.41-.705-2-.952-2.36-1.325-2-2.048c.339-.743 2.5-2.247 2.5-5.5S25.214 10 23 10m3 17c-.229-.454-1.32-1.447-4.5-2.5-3.161-1.072-3.088-1.236-2.5-2.5.588-1.283 4-3.353 4-9 0-5.667-3.269-8-7-8-3.73 0-7 2.333-7 8s2.912 7.717 3.5 9c.588 1.283.161 1.447-3 2.5C6.339 25.572 6 27 6 27",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1z",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 23s.41-.705 2-.952S7.36 20.723 7 20c-.339-.743-2.5-2.247-2.5-5.5S6.786 10 9 10",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
function SvgGroupsBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}
export default SvgGroupsBlue;